import React from "react";

import { useUser } from "@components/user-context";
import { H1 } from "@components/utilities";
import { type InstallationScriptDetails } from "@north-beam/nb-common";

import { NorthbeamPixelTag } from "./northbeam-pixel-tag";
import { ShopifyOrderStatusTag } from "./shopify-order-status-tag";
import { ShopifyPostPurchaseUpsellTag } from "./shopify-post-purchase-upsell-tag";

interface TrackingScriptTagsProps {
  installationScripts: InstallationScriptDetails;
}
export const TrackingScriptTags = ({
  installationScripts,
}: TrackingScriptTagsProps): React.ReactElement => {
  const { user } = useUser();
  return (
    <>
      <H1>Northbeam Pixel and Event Tracking</H1>
      {user.isPixelConfigurationSubaccount ? (
        <div>
          This is a subaccount, the pixel is installed using your global
          account.
          <div>
            Please go to your global account to get the scripts to install the
            Northbeam Pixel.
          </div>
        </div>
      ) : (
        <>
          <p>
            Please proceed through each of the following instructions to add
            Northbeam&apos;s tracking script tags to the appropriate locations.
          </p>
          <hr />
          <NorthbeamPixelTag installationScripts={installationScripts} />
          <ShopifyOrderStatusTag installationScripts={installationScripts} />
          <ShopifyPostPurchaseUpsellTag
            installationScripts={installationScripts}
          />
        </>
      )}
    </>
  );
};
